module.exports = __webpack_public_path__ + "static/highlight-pattern2-33982417a04f7bf8dd966ea00b9e14f6.svg";